import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

export default function DisplayCupsArray(props) {

    return <div id="select-cups">
        <h3>Select a cup</h3>
        {
            props.width >= 600 ?
                <ul id="cup-table">
                    {
                        defaultRows.map((element, index) => {
                            return <li className="cupimg" key={index}>
                                <img
                                    role="button"
                                    className="cup-icon"
                                    id={element}
                                    src={props.cups.get(element).emblem}
                                    alt={`${props.cups.get(element).display} Cup Emblem`}
                                    title={`${props.cups.get(element).display} Cup`}
                                    tabIndex="0"
                                    draggable={false}
                                    onClick={() => props.setShownCup(element)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            props.setShownCup(element)
                                        }
                                    }}
                                />
                            </li>
                        })
                    }
                </ul>
                : <div className="cup-dropdown"
                    style={{ display: "flex", flexDirection: "row", alignItems: "center", marginTop: 10 }}>
                    <img
                        className="cup-emblem"
                        src={props.cups.get(props.shownCup).emblem}
                        alt={`${props.cups.get(props.shownCup).display} Cup Emblem`}
                        title={`${props.cups.get(props.shownCup).display} Cup`}
                        draggable={false}
                    />

                    <FormControl
                        sx={{
                            marginLeft: 1.2
                        }}
                    >
                        <InputLabel id="cups-select" sx={{ color: "#eee" }}>Select a cup</InputLabel>
                        <Select
                            value={props.shownCup}
                            onChange={(e) => props.setShownCup(e.target.value)}
                            tabIndex={0}
                            label="Select a cup"
                            labelId='cup-select'
                            variant="outlined"
                            autoWidth={false}
                            sx={{
                                "& .MuiSelect-icon": {
                                    color: "#eee"
                                },
                                "& .MuiSelect-select": {
                                    color: "#eee",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#eee",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "white",
                                },
                                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "white",
                                }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: "#333",
                                        color: "white",
                                        "& .MuiMenuItem-root": {
                                            "&:hover": {
                                                backgroundColor: "#555",
                                            },
                                            "&.Mui-selected": {
                                                backgroundColor: "#555",
                                                "&:hover": {
                                                    backgroundColor: "#666",
                                                }
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            {
                                allCupsArray.map((element, index) => <MenuItem
                                    value={element}
                                    key={index}
                                >
                                    {props.cups.get(element).display + " Cup"}
                                </MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </div>
        }
    </div>
}

// holds the different versions of how tracks can be displayed:
// either as a table (in game), or as a drop down when the screen width is too narrow.
const defaultRows = [
    "mushroom", "flower", "star", "special", "egg", "crossing",
    "shell", "banana", "leaf", "lightning", "triforce", "bell",
    "golden-dash", "lucky-cat", "turnip", "propeller", "rock", "moon",
    "fruit", "boomerang", "feather", "cherry", "acorn", "spiny"
];

const allCupsArray = [
    "mushroom", "flower", "star", "special",
    "shell", "banana", "leaf", "lightning",
    "egg", "triforce", "crossing", "bell",
    "golden-dash", "lucky-cat", "turnip", "propeller",
    "rock", "moon", "fruit", "boomerang",
    "feather", "cherry", "acorn", "spiny"
];